import React from 'react';
import LoadMask from '../../../Utils/LoadMask';

function DeleteVendorModal(props) {
   const { vendor, onClose, onConfirm, loading } = props;
   if (!vendor) return null;

   return (
      <div className="modal fade show" style={{ display: 'block' }}>
         <div className="modal-dialog modal-sm">
            <div className="modal-content">
               <LoadMask loading={loading} dark blur>
                  <div className="modal-header">
                     <h5 className="modal-title">Confirm Delete</h5>
                     <button className="close" onClick={onClose}>
                        <span className="close-content" style={{ fontWeight: '700 !important' }}>
                           &times;
                        </span>
                     </button>
                  </div>

                  <div className="modal-body">
                     <p className="mb-1">Are you sure you want to delete:</p>
                     <p className="font-weight-600">{vendor.name}</p>
                     <p className="text-muted mb-0" style={{ fontSize: '0.82rem' }}>
                        This action cannot be undone. All associated driver accounts will also be removed.
                     </p>
                  </div>

                  <div className="modal-footer">
                     <button className="btn btn-outline-secondary btn-sm" onClick={onClose}>
                        Cancel
                     </button>
                     <button className="btn btn-danger btn-sm" onClick={onConfirm}>
                        <i className="fa fa-trash mr-1"></i> Delete
                     </button>
                  </div>
               </LoadMask>
            </div>
         </div>

         <div className="modal-backdrop fade show"></div>
      </div>
   );
}

export default DeleteVendorModal;
